import "./App.css";
import Hero from "./components/hero";
import About from "./components/about";
import WhyChoose from "./components/whyChoose";
import HowItwork from "./components/howItWorks";
import MeetCoach from "./components/meetCoach";
import Faqs from "./components/faqs";
import Footer from "./layout/footer";
import DemoVideo from "./components/demoVideo";
import Navbar from "./layout/navbar";
import { useEffect } from "react";
import { storeQueryParams } from "./utils/utm";

function App() {
  useEffect(() => {
    storeQueryParams();
  }, []);
  return (
    <div className="App">
      <div className="fixed top-0 left-0 right-0 z-[9999]">
        <Navbar />
      </div>
      <Hero />
      <About />
      {/* <DemoVideo /> */}
      <WhyChoose />
      <HowItwork />
      <MeetCoach />
      <Faqs />
      <Footer />
    </div>
  );
}

export default App;
